import React, {Component} from 'react';
import { Link } from 'react-router';
// import ReactGA from 'react-ga';
// import data from '../../content/checklistContent.js';
import './Home.css';

export default class Home extends Component {
    
    componentDidMount() {
        this.props.rerender();
    }
    
    render() {
        return (
            <div className='page-container'>
                <div className='header'>
                    <img src='images/financial-health-tool.png' className='page-logo' alt='page-logo'/>
                    
                    <h1 className="title is-3 page-title is-spaced">
                        The Startup Financial Health Checklist
                    </h1>
                    
                    <p className='description'>
                        <strong>82% of businesses fail because of a poor understanding of cash flow and cash management. Don’t be a statistic.</strong>
                    </p>
                    
                    <Link to="/checklist">
                        <button>
                            VIEW CHECKLIST
                        </button>
                    </Link>
                    
                    <p className='bottom-text'>
                        We spoke to over 150 businesses and financial experts to identify the financial health metrics any startup should know.
                    </p>
                </div>
            </div>
        )
    }
    
}


// WEBPACK FOOTER //
// src/components/pages/Home.js